import { render, staticRenderFns } from "./create-seller.vue?vue&type=template&id=46c28c06&"
import script from "./create-seller.vue?vue&type=script&lang=js&"
export * from "./create-seller.vue?vue&type=script&lang=js&"
import style0 from "./create-seller.vue?vue&type=style&index=0&id=46c28c06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports